var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"enter-active-class":"transition-opacity duration-150 ease-in","enter-class":"opacity-0","enter-to-class":"opacity-100","leave-active-class":"transition-opacity duration-150 ease-out","leave-class":"opacity-100","leave-to-class":"opacity-0"}},[(_vm.xActivityIndicator)?_c('div',{staticClass:"flex flex-row",style:({ color: _vm.backgroundColor }),attrs:{"data-cy":"surfaceActivityIndicator"}},[(_vm.isDesktop)?[_vm._l((_vm.activeContributorsList),function(user,index){return _c('div',{key:'user-' + index,class:[
          {
            'w-5.5': index === _vm.activeContributorsList.length - 1,
            'w-4.75': index !== _vm.activeContributorsList.length - 1,
          },
          'h-5.5',
          'relative',
          'hidden',
          'sm:flex',
        ]},[_c('avatar-image',{class:['absolute', 'border-current', 'border-solid', 'border', 'top-0', 'left-0'],style:({
            zIndex: _vm.activeContributorsList.length - index,
          } /* one to the left is in front of the one to the right*/),attrs:{"user":user,"width":20,"height":20}})],1)}),_vm._v(" "),(_vm.xAdditionalContributors)?_c('div',{class:[
          'hidden',
          'sm:block',
          'ml-1.5',
          'mt-px',
          'text-14',
          {
            'text-light-text-300': _vm.backgroundLuminance === 'dark',
            'text-dark-text-300': _vm.backgroundLuminance === 'light',
          },
        ]},[_vm._v("\n        +"+_vm._s(_vm.numberOfAdditionalContributors)+"\n      ")]):_vm._e()]:_vm._e(),_vm._v(" "),_c('surface-activity-svg',{class:_vm.isDesktop && 'sm:ml-1.5',attrs:{"width":"20","height":"20","color-scheme":_vm.backgroundLuminance === 'dark' ? 'light' : 'dark'}})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }